import { retailCockpitTabViews, type RetailCockpitView } from "../../pages/retail/cockpit/retailCockpitViews";
import { onlineCockpitTabViews, type OnlineCockpitView } from "../../pages/online/cockpit/onlineCockpitViews";
import {
    allScreenTabCodes,
    canAccessScreenTab,
    allowedScreenTabs,
    resolveAllowedScreenTab,
    screenTabManageCode,
    screenTabViewCode,
    tabCodeSegment,
} from "./screenTabPermissions";
import type { User } from "./types";

export { tabCodeSegment as cockpitTabCodeSegment };

const RETAIL_PREFIX = "retail.cockpit";
const ONLINE_PREFIX = "online.cockpit";

export function retailCockpitTabViewCode(view: string): string {
    return screenTabViewCode(RETAIL_PREFIX, view);
}

export function retailCockpitTabManageCode(view: string): string {
    return screenTabManageCode(RETAIL_PREFIX, view);
}

export function onlineCockpitTabViewCode(view: string): string {
    return screenTabViewCode(ONLINE_PREFIX, view);
}

export function onlineCockpitTabManageCode(view: string): string {
    return screenTabManageCode(ONLINE_PREFIX, view);
}

export function allRetailCockpitTabCodes(): string[] {
    return allScreenTabCodes(RETAIL_PREFIX, retailCockpitTabViews);
}

export function allOnlineCockpitTabCodes(): string[] {
    return allScreenTabCodes(ONLINE_PREFIX, onlineCockpitTabViews);
}

export function retailCockpitRouteAccessCodes(): string[] {
    return [
        ...allRetailCockpitTabCodes(),
        "retail.cockpit.view",
        "retail.cockpit.manage",
    ];
}

export function onlineCockpitRouteAccessCodes(): string[] {
    return [
        ...allOnlineCockpitTabCodes(),
        "online.cockpit.view",
        "online.cockpit.manage",
    ];
}

export function canAccessRetailCockpitTab(user: User | null, view: RetailCockpitView): boolean {
    return canAccessScreenTab(user, RETAIL_PREFIX, view, retailCockpitTabViews);
}

export function canAccessOnlineCockpitTab(user: User | null, view: OnlineCockpitView): boolean {
    return canAccessScreenTab(user, ONLINE_PREFIX, view, onlineCockpitTabViews);
}

export function allowedRetailCockpitViews(user: User | null): RetailCockpitView[] {
    return allowedScreenTabs(user, RETAIL_PREFIX, retailCockpitTabViews);
}

export function allowedOnlineCockpitViews(user: User | null): OnlineCockpitView[] {
    return allowedScreenTabs(user, ONLINE_PREFIX, onlineCockpitTabViews);
}

export function resolveAllowedRetailCockpitView(
    user: User | null,
    requested: RetailCockpitView,
): RetailCockpitView {
    return resolveAllowedScreenTab(user, RETAIL_PREFIX, retailCockpitTabViews, requested);
}

export function resolveAllowedOnlineCockpitView(
    user: User | null,
    requested: OnlineCockpitView,
): OnlineCockpitView {
    return resolveAllowedScreenTab(user, ONLINE_PREFIX, onlineCockpitTabViews, requested);
}
